export const onClientEntry = () => {
  const pushConsentToDataLayer = () => {
    if (
      typeof window === 'undefined' ||
      !window.Cookiebot ||
      !window.dataLayer
    ) {
      return
    }

    window.dataLayer.push({
      event: 'cookiebot_consent_ready',
      cookiebot_consent_marketing: window.Cookiebot.consent.marketing,
      cookiebot_consent_statistics: window.Cookiebot.consent.statistics,
      cookiebot_consent_preferences: window.Cookiebot.consent.preferences,
    })
  }

  window.addEventListener('CookiebotOnConsentReady', pushConsentToDataLayer)
  window.addEventListener('CookiebotOnAccept', pushConsentToDataLayer)
  window.addEventListener('CookiebotOnDecline', pushConsentToDataLayer)
}
